import { FoodType } from "shared/types/food";
import { HotelOfferDetail, HotelRoomsDetail } from "shared/types/hotels";

import { HotelRoomPoliciesState } from "../../lib/hotels/hotelRoomPolicies";
import * as actionTypes from "../actions/actionTypes";

export type returnType = {
  hotelOfferDetail: HotelOfferDetail;
  currency: string;
  hotelRoomsDetail: HotelRoomsDetail;
  travelPoliciesResult: any;
  travelPolicies: any;
};

export interface HotelsState {
  oHotelOffers: Record<string, HotelOfferDetail> | {};
  aHotelOffers: string[] | [];
  hotelRooms: Record<string, HotelRoomsDetail> | {};
  priceActualizationHotelOffers: Record<string, any> | {};
  imageGalleryHotelIndicator: string | null;
  imageGalleryIndex: number;
  travelPolicies: any[];
  travelPoliciesResults: any[];
  travelPoliciesRooms: any[];
  travelPoliciesRoomsResults: any[];
  hotelRoomPolicies: Record<string, HotelRoomPoliciesState>;
  searchHotelRoomsQuery: string;
  map: {
    selectedMapLocationTo: { lat: number; lng: number } | null;
    selectedMapLocationFrom: string;
    placeId: string;
    date: string | null;
    lastOptions: any[];
    accumulatedHotelIndicators: string[];
    travelMode: "DRIVING" | "WALKING";
  };
  food: FoodType[];
}

const initState: HotelsState = {
  oHotelOffers: {},
  aHotelOffers: [],
  hotelRooms: {},
  priceActualizationHotelOffers: {},
  imageGalleryHotelIndicator: null,
  imageGalleryIndex: 0,
  travelPolicies: [],
  travelPoliciesResults: [],
  travelPoliciesRooms: [],
  travelPoliciesRoomsResults: [],
  hotelRoomPolicies: {},
  searchHotelRoomsQuery: "",
  map: {
    selectedMapLocationTo: null,
    selectedMapLocationFrom: "",
    placeId: "",
    date: null,
    lastOptions: [],
    accumulatedHotelIndicators: [],
    travelMode: "DRIVING",
  },
  food: [],
};

const reducer = (state = initState, action: any): HotelsState => {
  switch (action.type) {
    case actionTypes.SET_HOTELS_VALUE:
      return { ...state, [action.data.name]: action.data.value };

    case actionTypes.SET_HOTEL_ROOMS_VALUE:
      return {
        ...state,
        hotelRooms: {
          ...state.hotelRooms,
          [action.data.name]: action.data.value,
        },
      };

    case actionTypes.SET_HOTEL_ROOM_POLICIES_VALUE:
      return {
        ...state,
        hotelRoomPolicies: {
          ...state.hotelRoomPolicies,
          [action.data.name]: action.data.value,
        },
      };

    case actionTypes.SET_MAP_LOCATION_TO:
      return {
        ...state,
        map: {
          ...state.map,
          selectedMapLocationTo: action.data,
        },
      };

    case actionTypes.SET_MAP_PLACE_ID:
      return {
        ...state,
        map: {
          ...state.map,
          placeId: action.data,
        },
      };

    case actionTypes.SET_MAP_LOCATION_FROM:
      return {
        ...state,
        map: {
          ...state.map,
          selectedMapLocationFrom: action.data,
        },
      };

    case actionTypes.SET_MAP_LAST_OPTIONS:
      return {
        ...state,
        map: {
          ...state.map,
          lastOptions: action.data,
        },
      };

    case actionTypes.ADD_ACCUMULATED_HOTEL_INDICATOR:
      return {
        ...state,
        map: {
          ...state.map,
          accumulatedHotelIndicators: [
            ...state.map.accumulatedHotelIndicators,
            action.data,
          ],
        },
      };

    case actionTypes.RESET_ACCUMULATED_HOTEL_INDICATORS:
      return {
        ...state,
        map: {
          ...state.map,
          accumulatedHotelIndicators: [],
        },
      };

    case actionTypes.SET_FOOD_DATA:
      return {
        ...state,
        food: action.data,
      };

    case actionTypes.SET_MAP_TRAVEL_MODE:
      return {
        ...state,
        map: {
          ...state.map,
          travelMode: action.data,
        },
      };

    case actionTypes.SET_MAP_DATE:
      return {
        ...state,
        map: {
          ...state.map,
          date: action.data,
        },
      };

    default:
      return state;
  }
};

export default reducer;
